import React from 'react'; 

const NotFound = () => {
 

    return (
        <div style={{ textAlign: 'center', height:"100vh",alignContent:"center"}}>
            <h1>404 - Sayfa Bulunamadı</h1>
            <p>Üzgünüz, aradığınız sayfa mevcut değil.</p>
       
        </div>
    );
};

export default NotFound;
